function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { closeModal } from "@common/actions";
import CustomScrollbar from "@common/components/CustomScrollbar";
import { SCROLLBAR } from "@common/services/responsive";
var Policies = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Policies, Component);
    var _super = _create_super(Policies);
    function Policies(props) {
        _class_call_check(this, Policies);
        var _this;
        _this = _super.call(this, props);
        _this.wrapperRef = null;
        _this.focusTimeout = null;
        return _this;
    }
    _create_class(Policies, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                this.focusTimeout = setTimeout(function() {
                    _this.wrapperRef.focus();
                }, 0);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearTimeout(this.focusTimeout);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, _$closeModal = _this_props.closeModal, text = _this_props.text, screenType = _this_props.screenType;
                return /*#__PURE__*/ _jsxs("div", {
                    tabIndex: "0",
                    ref: function(node) {
                        return _this.wrapperRef = node;
                    },
                    className: "modal policy",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            onClick: _$closeModal,
                            className: "icon icon-clear pointer"
                        }),
                        screenType.web ? /*#__PURE__*/ _jsx(CustomScrollbar, {
                            className: "privacy-policy-scrollbar",
                            hideTracksWhenNotNeeded: true,
                            style: {
                                width: SCROLLBAR.FAQ.width
                            },
                            thumbSize: SCROLLBAR.FAQ.thumbSize,
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "message-wrapper",
                                dangerouslySetInnerHTML: {
                                    __html: text
                                }
                            })
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "message-wrapper",
                            dangerouslySetInnerHTML: {
                                __html: text
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return Policies;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, screenType = param.screenType;
    return {
        i18n: i18n,
        screenType: screenType
    };
};
export default connect(mapStateToProps, {
    closeModal: closeModal
})(Policies);
